export default {
  english: {
    memberSince: 'Member since',
    title: 'My profile',
  },
  french: {
    memberSince: 'Membre depuis le',
    title: 'Mon profil',
  },
  arabic: {
    memberSince: 'عضو منذ',
    title: 'ملفي',
  },
  hebrew: {
    memberSince: 'חבר מאז',
    title: 'הפרופיל שלי',
  },
  persian: {
    memberSince: 'عضو از',
    title: 'پروفایل من',
  },
}
